import { render, staticRenderFns } from "./AutoFormatTextField.vue?vue&type=template&id=43367f72"
import script from "./AutoFormatTextField.vue?vue&type=script&lang=js"
export * from "./AutoFormatTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports